import Notification from '../../core/Notification';
import ProjectProvider from '../../core/providers/ProjectProvider';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../withGShoc';
import ProjectBasics from './ProjectBasics';
import VersionWarning from '../VersionWarning';

class ProjectData extends React.Component {

    onUpdate = (property, lang, index) => (value) => this.props.onUpdate(property, value, lang, index);

    onDelete = (property, lang, index) => (value) => this.props.onDelete(property, value, lang, index);

    handleAddProjectLang = (lang) => this.props.onAdd('projectLang', lang);

    handleChangeColour = (colour) => {
        this.props.data.projectColour !== undefined ?
            this.props.onUpdate('projectColour', colour)
            :
            this.props.onAdd('projectColour', colour);
    };

    handleEnableSkosXL = () => {
        this.props.data.skosXL !== undefined ? this.props.onUpdate('skosXL', true) : this.props.onAdd('skosXL', true);
    };

    handleExcludeFromImportAssociation = (status) => {
        this.props.data.excludeFromImportAssociation !== undefined ?
            this.props.onUpdate('excludeFromImportAssociation', status)
            :
            this.props.onAdd('excludeFromImportAssociation', true);
    };

    addNewIRI = (property) => (value, datatype = null) => this.props.onAdd(property, value, null, datatype);

    addNewLiteral = (property) => (language, text) => this.props.onAdd(property, text, language);

    render() {

        const { data, entitlement, projectType } = this.props;

        if (data.isVersionOfProject) return <VersionWarning />;
        if (projectType && projectType !== data.type) return <Notification text="You are trying to view an incorrect project type." />;

        return (
            <ProjectProvider value={data}>
                <ProjectBasics
                    handleAddProjectLang={this.handleAddProjectLang}
                    handleChangeColour={this.handleChangeColour}
                    handleEnableSkosXL={this.handleEnableSkosXL}
                    handleExcludeFromImportAssociation={this.handleExcludeFromImportAssociation}
                    onDelete={this.onDelete}
                    onUpdate={this.onUpdate}
                    entitlement={entitlement}
                    addNewIRI={this.addNewIRI}
                    addNewLiteral={this.addNewLiteral}
                    data={data}
                />
            </ProjectProvider>
        );
    }
}

ProjectData.propTypes = {
    entitlement: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    projectType: PropTypes.string.isRequired,
    onAdd: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired
};

export default withGS(ProjectData);